import { useQuery } from '@tanstack/react-query';
import { boatApi } from '../services/boatApi';

// Canonical models scoped to the chosen boat make. Disabled until a make is
// chosen (an empty/unknown make has no catalog models — the field stays free
// text). queryKey includes the manufacturer so switching makes refetches.
export function useModelOptions(manufacturer: string, enabled = true) {
  return useQuery({
    queryKey: ['inventory', 'model-options', manufacturer],
    queryFn: () => boatApi.getFieldOptions('model', undefined, manufacturer),
    enabled: enabled && manufacturer.trim().length > 0,
    staleTime: 5 * 60_000,
  });
}
